import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';
import type { ReactNode } from 'react';
import type { CellRendererValueProps } from '../cellRenderer.types';

export type ScheduleRuntimeProps = CellRendererValueProps<string | number> & {
  exceedsSchedule: boolean;
  warningIcon?: ReactNode;
  truncateText?: boolean;
};

/** Displays run time with danger styling and a supplied warning icon when the schedule interval is exceeded. */
export const ScheduleRuntime = ({
  value,
  exceedsSchedule,
  warningIcon,
  truncateText = false,
}: ScheduleRuntimeProps) => (
  <span {...stylex.props(styles.root, truncateText && styles.constrained, exceedsSchedule && styles.exceeded)}>
    <span {...stylex.props(truncateText && styles.truncatedText)}>{value}</span>
    {exceedsSchedule && warningIcon ? <span {...stylex.props(styles.warningIcon)}>{warningIcon}</span> : null}
  </span>
);

const styles = stylex.create({
  root: { display: 'inline-flex', alignItems: 'center', gap: '0.25rem' },
  constrained: { maxWidth: '100%' },
  exceeded: { color: colors.borderInvalid },
  warningIcon: { display: 'flex', flexShrink: 0, alignItems: 'center' },
  truncatedText: { minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
});
